import { Notification } from 'element-ui'

exports.install = function (Vue, options) {
  // 编码
  Vue.prototype.BaseEncode = function (params) {
    let Base64 = require('js-base64').Base64
    return Base64.encode(params)
  }
  // 解码
  Vue.prototype.BaseDecode = function (params) {
    let Base64 = require('js-base64').Base64
    return Base64.decode(params)
  }

  // 成功通知
  Vue.prototype.success = function (message) {
    Notification({
      title: '成功',
      message: message,
      type: 'success',
      duration: 2000
    })
  }

  // 失败通知
  Vue.prototype.error = function (message) {
    Notification({
      title: '错误',
      message: message,
      type: 'error',
      duration: 3000
    })
  }

  // 警告通知
  Vue.prototype.warning = function (message) {
    Notification({
      title: '警告',
      message: message,
      type: 'warning',
      duration: 3000
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/global/index.js